import { Box, alpha } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { IconButton, Typography } from "@mui/material";

import {
  AiOutlineClear,
  AiOutlineDelete,
  AiOutlineMinusCircle,
  AiOutlinePlusCircle,
} from "react-icons/ai";
import { getRandomHexColor } from "../../utilities/randomHexColor";
import { getIconByName } from "../../utilities/getIcons";

interface ItemProps {
  name: string;
  quantity: string;
  notes: string;
  iconLabel: string;
  index: number;
  imageUrl: string;
  decreaseQuantity: (index: number) => void;
  increaseQuantity: (index: number) => void;
  handleResetItem: (index: number) => void;
  handleRemoveItem: (index: number) => void;
}

export const Item: FC<ItemProps> = ({
  name,
  quantity,
  decreaseQuantity,
  index,
  notes,
  increaseQuantity,
  handleResetItem,
  handleRemoveItem,
}) => {
  const [itemColor, setItemColor] = useState(getRandomHexColor());

  useEffect(() => {
    const interval = setInterval(() => {
      setItemColor(getRandomHexColor());
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: alpha(
          Number(quantity) < 2
            ? "#ff0000"
            : Number(quantity) < 6
            ? "#005eff"
            : "#00ff3c",
          Number(quantity) < 1 ? 0.5 : 0.6
        ),
        borderRadius: 5,
        width: 500,
        maxWidth: "90vw",
        marginY: 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: alpha(
            Number(quantity) < 2
              ? "#ff0000"
              : Number(quantity) < 6
              ? "#005eff"
              : "#00ff3c",
            Number(quantity) < 1 ? 0.5 : 0.6
          ),
          borderRadius: 5,
          height: 100,
          width: 500,
          maxWidth: "90vw",
          justifyContent: "space-around",
          // marginY: 5,
        }}
        display="flex"
        alignItems="center"
      >
        <IconButton onClick={() => decreaseQuantity(index)}>
          <AiOutlineMinusCircle />
        </IconButton>
       
       

        <Typography
          className={Number(quantity) < 1 ? "i-fs" : ""}
          sx={{
            color: Number(quantity) < 1 ? itemColor : "#000000",
            backgroundColor: Number(quantity) < 1 ? "white" : "white",
            height: "70px",
            width: "70px",
            fontSize: 50,
            border: "1px solid",
            borderRadius: 16,
            padding: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
           {getIconByName(name)}
        </Typography>
        <Typography fontWeight={900} variant="body1">{name.toUpperCase()}</Typography>
        <IconButton onClick={() => increaseQuantity(index)}>
          <AiOutlinePlusCircle />
        </IconButton>
        <IconButton onClick={() => handleResetItem(index)}>
          <AiOutlineClear />
        </IconButton>
        <IconButton onClick={() => handleRemoveItem(index)}>
          <AiOutlineDelete />
        </IconButton>
      </Box>
      <Box px={4} m={2}>
        <Typography variant="h5"> Quantity : {quantity}</Typography>
        <Typography variant="h5"> Notes : {notes}</Typography>
       
      </Box>
    </Box>
  );
};
